import { ApolloLink, HttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { KEYS } from "utils/constants";
import { GRAPHQL_HTTP_URL } from "utils/helpers/apiOrigin";

// Zitadel sessions authenticate via the httpOnly `kayros_at` cookie; their
// localStorage token is only a "session" sentinel. Guest / domain-signin flows
// instead hold a real JWT in localStorage. Attach the Bearer header only for a
// real token so guest requests stay authenticated, while cookie sessions keep
// relying on the credentialed request.
const SESSION_SENTINEL = "session";

const authHeaderLink = setContext((_, context) => {
  const headers = context.headers || {};
  const token = localStorage.getItem(KEYS.ACCESS_TOKEN);
  if (token && token !== SESSION_SENTINEL) {
    return { headers: { ...headers, authorization: `Bearer ${token}` } };
  }
  return { headers };
});

const httpLink = new HttpLink({
  uri: GRAPHQL_HTTP_URL,
  credentials: "include",
});

const bffLink = ApolloLink.from([authHeaderLink, httpLink]);

export default bffLink;
